import {
    Box,
    Divider,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Typography,
} from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import { useCloseMobileNav, useNavCollapsed } from "../../components/DashboardLayoutContext";

const NAV = [
    { to: "/System/dashboard", label: "Overview", icon: HomeOutlinedIcon },
    { to: "/System/schools", label: "Registered schools", icon: SchoolOutlinedIcon },
    { to: "/System/payments", label: "Subscription payments", icon: PaymentsOutlinedIcon },
];

export default function SystemSideBar() {
    const location = useLocation();
    const collapsed = useNavCollapsed();
    const closeMobileNav = useCloseMobileNav();

    return (
        <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
            <Box sx={{ px: collapsed ? 1 : 2, py: 2 }}>
                {!collapsed && (
                    <Typography variant="subtitle2" color="text.secondary" sx={{ fontSize: 11, letterSpacing: 1, textTransform: "uppercase" }}>
                        Platform
                    </Typography>
                )}
                {!collapsed && (
                    <Typography variant="h6" sx={{ fontWeight: 700, lineHeight: 1.2 }}>
                        System console
                    </Typography>
                )}
            </Box>
            <Divider />
            <List sx={{ flex: 1, px: 1, py: 1 }}>
                {NAV.map(({ to, label, icon: Icon }) => {
                    const active = location.pathname === to || location.pathname.startsWith(`${to}/`);
                    return (
                        <ListItemButton
                            key={to}
                            component={Link}
                            to={to}
                            selected={active}
                            onClick={closeMobileNav}
                            sx={{ borderRadius: 1, mb: 0.5 }}
                        >
                            <ListItemIcon sx={{ minWidth: collapsed ? 0 : 40 }}>
                                <Icon fontSize="small" />
                            </ListItemIcon>
                            {!collapsed && <ListItemText primary={label} />}
                        </ListItemButton>
                    );
                })}
            </List>
            <Divider />
            <List sx={{ px: 1, py: 1 }}>
                <ListItemButton component={Link} to="/System/profile" selected={location.pathname === "/System/profile"} onClick={closeMobileNav}>
                    <ListItemIcon sx={{ minWidth: collapsed ? 0 : 40 }}>
                        <AccountCircleOutlinedIcon fontSize="small" />
                    </ListItemIcon>
                    {!collapsed && <ListItemText primary="My account" />}
                </ListItemButton>
                <ListItemButton component={Link} to="/logout" onClick={closeMobileNav}>
                    <ListItemIcon sx={{ minWidth: collapsed ? 0 : 40 }}>
                        <ExitToAppIcon fontSize="small" />
                    </ListItemIcon>
                    {!collapsed && <ListItemText primary="Sign out" />}
                </ListItemButton>
            </List>
        </Box>
    );
}
